<template>
  <div class="serviceArea">
    <div class="row row-cols-1 row-cols-md-3 g-5">
      <div class="col" v-for="service in serviceData" :key="service._id">
        <div class="card h-100">
          <ImageList class="showcase-image" :data="service" />

          <div class="card-body px-4">
            <h5
              class="card-title service-title text-center"
              v-if="$i18n.locale === 'CH'"
            >
              {{ service.titleCh }}
            </h5>
            <h5
              class="card-title service-title text-center"
              v-if="$i18n.locale === 'EN'"
            >
              {{ service.titleEn }}
            </h5>

            <p class="card-text" v-if="$i18n.locale === 'CH'">
              {{ service.descriptionCh }}
            </p>
            <p class="card-text" v-if="$i18n.locale === 'EN'">
              {{ service.descriptionEn }}
            </p>
          </div>
          <div class="card-footer text-center">
            <small class="service-price-text">
              <span>{{ $t("homePage.service.price") }}</span>
              {{ "$" + service.price }}
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageList from "./ImageList.vue";

export default {
  name: "AboutUs",
  components: { ImageList },
  props: ["serviceData"],
};
</script>

<style scoped>
.showcase-image {
  height: 300px;
  width: 100%;
  object-fit: cover;
}

.service-title,
.card-footer {
  font-size: 1.5rem;
}

.service-price-text {
  font-size: 2rem;
  font-family: "Great Vibes", cursive;
}
</style>
